'use strict';

var _tslib = require('./_tslib-D25eJ2i9.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const ScreenReaderOnlyContainer = styled__default.default.p(() => ({
    position: "absolute",
    clip: "rect(0, 0, 0, 0)",
    display: "block",
    fontSize: "1px",
    lineHeight: "1px",
    padding: 0,
    border: 0,
    outline: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    height: "1px",
    width: "1px",
}));

const ScreenReaderOnly = (_a) => {
    var { text } = _a, props = _tslib.__rest(_a, ["text"]);
    return React__default.default.createElement(ScreenReaderOnlyContainer, Object.assign({}, props), text);
};
var ScreenReaderOnly$1 = React__default.default.memo(ScreenReaderOnly);

exports.ScreenReaderOnly = ScreenReaderOnly$1;
//# sourceMappingURL=ScreenReaderOnly-Bo2uWdwZ.js.map
